import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

const Navbar = () => {
  const { settings } = useSiteSettings();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/machines', label: 'Machines' },
    { path: '/occasions', label: 'Occasions' },
    { path: '/location', label: 'Location' },
    { path: '/services', label: 'Services' },
    { path: '/realisations', label: 'Réalisations' },
    { path: '/blog', label: 'Blog' },
    { path: '/a-propos', label: 'À propos' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src={settings.logo} 
              alt="AKM Laser" 
              className="h-14 w-14 transition-transform group-hover:scale-110"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold" style={{ color: '#5C3A21' }}>AKM Laser</span>
              <span className="text-xs text-gray-600">Experts en machines laser</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isActive(link.path)
                    ? 'text-white shadow-md'
                    : 'text-gray-700 hover:bg-#F5EBDD/20'
                }`}
                style={isActive(link.path) ? { backgroundColor: '#5C3A21' } : {}}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="ml-4 px-6 py-2.5 rounded-lg text-white font-semibold shadow-md hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
              style={{ backgroundColor: '#5C3A21' }}
            >
              Demander un devis
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" style={{ color: '#5C3A21' }} />
            ) : (
              <Menu className="w-6 h-6" style={{ color: '#5C3A21' }} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-xl">
          <div className="px-4 py-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isActive(link.path)
                    ? 'text-white shadow-md'
                    : 'text-gray-700 hover:bg-#F5EBDD/20'
                }`}
                style={isActive(link.path) ? { backgroundColor: '#5C3A21' } : {}}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full text-center px-6 py-3 rounded-lg text-white font-semibold shadow-md mt-4"
              style={{ backgroundColor: '#5C3A21' }}
            >
              Demander un devis
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
